import React from 'react';
import styles from './page-title-component.module.css';
import { PageTitleProps } from './page-title-type';
import { HtmlContainer } from '../../html-container';

export const PageTitle: React.FC<PageTitleProps> = ({
    title,
    subtitle,
    subtitleIsHtml,
    bordered,
    centered,
    uppercase,
}: PageTitleProps) => {
    const wrapperClass = `${styles.pageTitle} ${centered ? styles.center : ''} ${uppercase ? styles.upper : ''}`;
    const mainClass = `${styles.title} ${!subtitle && bordered ? styles.border : ''}`;
    const subClass = `${styles.subtitle} ${subtitle && bordered ? styles.border : ''}`;

    return (
        <React.Fragment>
            <div className={wrapperClass}>
                {title && <div className={mainClass}>{title}</div>}
                {subtitle && !subtitleIsHtml && <div className={subClass}>{subtitle}</div>}
                {subtitle && subtitleIsHtml && <HtmlContainer className={subClass} htmlContent={subtitle} />}
            </div>
        </React.Fragment>
    );
};
